import {observer} from 'mobx-react';
import React from 'react';
import {PromiseMessage} from '../../../../lib/components';
import {EditContentStore} from './EditContentStore';

@observer
export class EditContentControls extends React.Component<{ store: EditContentStore }> {
  render() {
    const store = this.props.store;
    const isLoading = store.save?.isPending === true;

    return (<>
      <div className="row justify-content-end" key="content-create-actions">
        <div className="col-auto">
          <button type="button" className="btn btn-primary"
                  onClick={store.complete}
                  disabled={isLoading || !store.valid}>
            Save
          </button>
          <button type="button" className="btn btn-primary"
                  onClick={store.cancel}
                  disabled={isLoading}>
            Cancel
          </button>
        </div>
      </div>
      <PromiseMessage label="Saving" state={store.save} align="right"/>
    </>);
  }
}
